const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.81,
    height: 24.81,
    viewBox: "0 0 24.81 24.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6648",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.905,
    cy: 11.905,
    r: 11.905,
    style: {
      stroke: "#ebeef7",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7903",
    d: "M0 0h23.806v23.806H0z",
    style: {
      fill: "none"
    },
    transform: "translate(.194)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7904",
    d: "M11.856 5.691 11.166 5 8.428 7.738 5.691 5 5 5.691l2.738 2.737L5 11.166l.691.691 2.737-2.738 2.738 2.738.691-.691-2.738-2.738z",
    transform: "translate(3.669 3.475)",
    style: {
      fill: "#4c69a4",
      stroke: "#4c69a4"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.eca55f2a69fd3fa63f655fa97de96a69.svg";
export { ForwardRef as ReactComponent };